import React, { lazy, Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import logo from "./assets/images/logo/xixlogo.png";

// ─── Layouts (small, load eagerly) ───────────────────────────────────────────
import AuthLayout from "./layouts/AuthLayout";
import MainLayout from "./layouts/MainLayout";
import ControlPanelLayout from "./layouts/ControlPanelLayout";
import ScrollToTop from "./component/ScrollToTop";

// ─── Lazy-loaded pages (each becomes its own JS chunk) ───────────────────────
const Home                = lazy(() => import("./pages/home/Home"));
const Login               = lazy(() => import("./pages/Auth/Login/Login"));
const ForgotPassword      = lazy(() => import("./pages/Auth/ForgotPassword/ForgotPassword"));
const ResetPassword       = lazy(() => import("./pages/Auth/resetPassword/ResetPassword"));
const Partners            = lazy(() => import("./pages/partners/Partners"));
const Contact             = lazy(() => import("./pages/Contact/Contact"));
const FilmPersonList      = lazy(() => import("./pages/filmCastCrew/FilmPersonList"));
const FilmPersonForm      = lazy(() => import("./pages/filmCastCrew/FilmPersonForm"));
const ActorProfilePage    = lazy(() => import("./pages/filmCastCrew/FilmPersonProfile"));
const AllOutlets          = lazy(() => import("./pages/all_outlets/AllOutlets"));
const OutletDetails       = lazy(() => import("./pages/outletDetails/OutletDetails"));
const ClientManagement    = lazy(() => import("./pages/management/client_management/ClientManagement"));
const ClientDashboard     = lazy(() => import("./pages/management/clientDashboard/ClientDashboard"));
const RegisterCommon      = lazy(() => import("./pages/register/Registercommon"));
const RegisterStore       = lazy(() => import("./pages/register/Registerstore"));
const Pending             = lazy(() => import("./pages/pendingregisteration/Pending"));
const Success             = lazy(() => import("./pages/register/sucess"));
const DigitalMarketing    = lazy(() => import("./pages/DigitalMarketing/DigitalMarketing"));
const Advertising         = lazy(() => import("./pages/Advertising/Advertising"));
const FilmProduction      = lazy(() => import("./pages/FilmProduction/FilmProduction"));
const Ourwork             = lazy(() => import("./component/ourwork/Ourwork"));
const ClientPortalDashboard = lazy(() => import("./pages/clientPortal/ClientPortalDashboard"));
const ClientSettings      = lazy(() => import("./pages/clientPortal/ClientSettings"));
const CategoryManagement  = lazy(() => import("./pages/management/categoryManagement/CategoryManagement"));
const { RegisterProvider } = require("./context/RegisterContext");

// ─── Lightweight page loader (used by Suspense only) ─────────────────────────
const PageLoader = () => (
	<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
		<div className={`splash-screen`}>
			<img className="h-50" src={logo} alt="Brand Logo" />
		</div>
	</div>
);

function App() {

	return (
		<ThemeProvider>
			<CookiesProvider>
			
					<BrowserRouter>
						<ScrollToTop />
						<RegisterProvider>
							<div className="main-content">
								<Suspense fallback={<PageLoader />}>
									<Routes>
										<Route element={<AuthLayout />}>
											<Route path="/login" element={<Login />} />
											<Route path="/forgot-password" element={<ForgotPassword />} />
											<Route path="/reset-password/:token" element={<ResetPassword />} />
											<Route path="/register" element={<RegisterCommon />} />
										</Route>

										<Route element={<MainLayout />}>
											<Route path="/" element={<Home />} />
											<Route path="/partners" element={<Partners />} />
											<Route path="/contact" element={<Contact />} />
											<Route path="/film-persons" element={<FilmPersonList />} />
											<Route path="/our-outlets" element={<AllOutlets />} />
											<Route path="/film-persons/new" element={<FilmPersonForm />} />
											<Route path="/film-persons/:id" element={<ActorProfilePage />} />
											<Route path="/whatdone" element={<Ourwork />} />

											

											<Route path="/whatWeDo/digitalMarketing" element={<DigitalMarketing />} />
											<Route path="/whatWeServe/advertising" element={<Advertising />} />
											<Route path="/whatWeServe/filmProduction" element={<FilmProduction />} />
											<Route path="/outlet/:outletId" element={<OutletDetails />} />
											
											<Route path="/register/store" element={<RegisterStore />} />
											<Route path="/pending" element={<Pending />} />
											<Route path="/success" element={<Success />} />
											{/* Client Portal */}
											<Route path="/my-portal" element={<ClientPortalDashboard />} />
											<Route path="/my-portal/settings" element={<ClientSettings />} />
										</Route>
										<Route path="/control-panel" element={<ControlPanelLayout />}>
												<Route path="client-dashboard" element={<ClientDashboard />} />
												<Route path="our-outlets" element={<AllOutlets />} />
												<Route path="client-management" element={<ClientManagement />} />
												<Route path="categories" element={<CategoryManagement />} />
												<Route path="register" element={<RegisterCommon />} />
												<Route path="register/store" element={<RegisterStore />} />
												<Route path="pending" element={<Pending />} />
												<Route path="success" element={<Success />} />
											</Route>
									</Routes>
								</Suspense>
							</div>
						</RegisterProvider>
					</BrowserRouter>
		</CookiesProvider>
		</ThemeProvider>
	);
}

export default App;
